(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
/* ============================================
   BOTANĒ — FAQ Page Interactions
   Category Filter + Accordion (Vanilla JS)
   ============================================ */
(function () {
  /* --- Category Filter --- */
  var pills = document.querySelectorAll('.faq-page__pill');
  var categoryGroups = document.querySelectorAll('.faq-page__category-group');
  var faqContent = document.getElementById('faq-content');

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var category = this.getAttribute('data-category');

      /* Update active pill */
      pills.forEach(function (p) {
        p.classList.remove('faq-page__pill--active');
      });
      this.classList.add('faq-page__pill--active');

      /* Close all open answers */
      var allQuestions = document.querySelectorAll('.faq-page__question');
      allQuestions.forEach(function (q) {
        q.setAttribute('aria-expanded', 'false');
        var answer = q.nextElementSibling;
        var toggle = q.querySelector('.faq-page__toggle');
        answer.style.maxHeight = null;
        answer.setAttribute('aria-hidden', 'true');
        toggle.textContent = '+';
        toggle.style.color = '#C4B5A0';
      });

      /* Show/hide category groups */
      categoryGroups.forEach(function (group) {
        if (category === 'all' || group.getAttribute('data-category') === category) {
          group.classList.remove('faq-page__category-group--hidden');
        } else {
          group.classList.add('faq-page__category-group--hidden');
        }
      });

      /* Smooth scroll to FAQ content */
      if (faqContent) {
        faqContent.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  /* --- Accordion --- */
  var questions = document.querySelectorAll('.faq-page__question');

  questions.forEach(function (button) {
    button.addEventListener('click', function () {
      var isOpen = this.getAttribute('aria-expanded') === 'true';
      var answer = this.nextElementSibling;
      var toggle = this.querySelector('.faq-page__toggle');
      var parentGroup = this.closest('.faq-page__category-group');

      /* Close other items in the same category group */
      if (parentGroup) {
        var siblingQuestions = parentGroup.querySelectorAll('.faq-page__question');
        siblingQuestions.forEach(function (otherButton) {
          if (otherButton !== button) {
            var otherAnswer = otherButton.nextElementSibling;
            var otherToggle = otherButton.querySelector('.faq-page__toggle');
            otherButton.setAttribute('aria-expanded', 'false');
            otherAnswer.style.maxHeight = null;
            otherAnswer.setAttribute('aria-hidden', 'true');
            otherToggle.textContent = '+';
            otherToggle.style.color = '#C4B5A0';
          }
        });
      }

      /* Toggle current item */
      if (isOpen) {
        this.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = null;
        answer.setAttribute('aria-hidden', 'true');
        toggle.textContent = '+';
        toggle.style.color = '#C4B5A0';
      } else {
        this.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        answer.setAttribute('aria-hidden', 'false');
        toggle.textContent = '\u2212';
        toggle.style.color = '#7D9B76';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-ingredients"] && !Shopify.designMode) return;
  try {
    
/* ============================================
   BOTANĒ — Ingredients Page Accordion
   Vanilla JS — No dependencies
   ============================================ */
(function() {
  var buttons = document.querySelectorAll('.ingredients-page__faq-question');

  buttons.forEach(function(button) {
    button.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var answer = this.nextElementSibling;
      var toggle = this.querySelector('.ingredients-page__faq-toggle');

      /* Close all other items */
      buttons.forEach(function(otherButton) {
        if (otherButton !== button) {
          otherButton.setAttribute('aria-expanded', 'false');
          var otherAnswer = otherButton.nextElementSibling;
          var otherToggle = otherButton.querySelector('.ingredients-page__faq-toggle');
          otherAnswer.style.maxHeight = null;
          otherToggle.textContent = '+';
        }
      });

      /* Toggle current item */
      if (expanded) {
        this.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = null;
        toggle.textContent = '+';
      } else {
        this.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        toggle.textContent = '\u2212';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-our-story"] && !Shopify.designMode) return;
  try {
    
/* ============================================
   BOTANĒ — FAQ Accordion (Vanilla JS)
   ============================================ */
(function () {
  var buttons = document.querySelectorAll('.our-story__faq-question');

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      var answer = this.nextElementSibling;
      var icon = this.querySelector('.our-story__faq-icon');
      var isOpen = this.getAttribute('aria-expanded') === 'true';

      /* Close all other items */
      buttons.forEach(function (otherButton) {
        if (otherButton !== button) {
          var otherAnswer = otherButton.nextElementSibling;
          var otherIcon = otherButton.querySelector('.our-story__faq-icon');
          otherButton.setAttribute('aria-expanded', 'false');
          otherAnswer.classList.remove('is-open');
          otherIcon.textContent = '+';
        }
      });

      /* Toggle current item */
      if (isOpen) {
        this.setAttribute('aria-expanded', 'false');
        answer.classList.remove('is-open');
        icon.textContent = '+';
      } else {
        this.setAttribute('aria-expanded', 'true');
        answer.classList.add('is-open');
        icon.textContent = '−';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
